import { waitForElement } from '@root/src/framework/scripts/helpers/element-ready';
import { App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland HeroBanner Component');

    const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountHeroBanner(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register HeroBanner Component', error);
        });

    return function destroyHeroBanner() {
        unMountHeroTakerOver(listeners);

        app.logger.debug('[DXA] HeroBanner destroyed');
    };
};

const mountHeroBanner = (listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment

    const heroTakeoverBanners = document.querySelectorAll<HTMLElement>('.hero-slide');

    for (const heroTakeoverBanner of heroTakeoverBanners) {
        const imageVideos = heroTakeoverBanner.querySelectorAll<HTMLElement>('.imageVideo');
        const videoContainer = heroTakeoverBanner.querySelector<HTMLElement>('.videoContainer');
        const overlay = heroTakeoverBanner.querySelector<HTMLElement>('.overlay');
        const overlaybackGround = heroTakeoverBanner.querySelector<HTMLElement>('.overlaybackGround');

        // This is the play button using style-5, not the big white one from video.liquid
        const slidePlayButton = heroTakeoverBanner.querySelector<HTMLElement>('#play');


        //For shortvideo autoplay for every two secs
        const shortVideo = heroTakeoverBanner.querySelector<HTMLVideoElement>('#shortVideo');
        void shortVideo?.play();

        if (shortVideo) shortVideo.muted = true;

        shortVideo?.addEventListener('ended', function () {
            setTimeout(() => {
                void shortVideo.play();
            }, 2000);
        });

        const handlePlayVideoClick = (event: Event) => {
            event.preventDefault();

            for (const imageVideo of imageVideos) {
                imageVideo.classList.add('!hidden');
            }

            if (overlay) overlay.style.display = 'none';
            if (overlaybackGround) overlaybackGround.style.display = 'none';
            if (shortVideo) {
                shortVideo.pause();
                shortVideo.currentTime = 0;
            }

            videoContainer?.classList.remove('hidden');
        };

        // Click listener for play/watch button
        if (slidePlayButton) {
            slidePlayButton.addEventListener('click', handlePlayVideoClick);
            listeners.push([slidePlayButton, 'click', handlePlayVideoClick]);
        }

        // There is an issue when using Youtube sources where controls aren't created until after this code is run
        // So wait for the controls to exist, then attempt the bind
        void waitForElement('.plyr__controls_left .stopVideo', heroTakeoverBanner)
            .then((elm) => {
                const stopVideo = heroTakeoverBanner.querySelector<HTMLElement>('.stopVideo');

                const handleStopVideoClick = (event: Event) => {
                    event.preventDefault();
                    // Youtube player also doesnt like pausing via Plyr, so check if pause button is visible, then click to pause video
                    const playVideo = heroTakeoverBanner.querySelector<HTMLElement>('.playVideo.plyr__control--pressed');
                    if (playVideo) {
                        playVideo.click();
                    }

                    for (const imageVideo of imageVideos) {
					 // This double hidden remove is here because hero-carousel.ts adds a hidden tag also
					 // There is so much duplicate code between this and that file it's a mess
					 // TODO: Untangle that mess of code
                        imageVideo.classList.remove('!hidden', 'hidden');
                    }

                    void shortVideo?.play();
                    if (overlay) overlay.style.display = 'flex';
                    // if (overlay) overlay.style.display = 'none';
                    if (overlaybackGround) overlaybackGround.style.display = 'flex';
                    // if (overlaybackGround) overlaybackGround.style.display = 'none';
                    if (shortVideo) shortVideo.muted = true;

                    videoContainer?.classList.add('hidden');
                };

                if (stopVideo) {
                    stopVideo.addEventListener('click', handleStopVideoClick);
                    listeners.push([stopVideo, 'click', handleStopVideoClick]);
                }
            });
    }
};

function unMountHeroTakerOver(listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
